import { Helmet } from "react-helmet-async";

const DEFAULT_KEYWORDS = `
  BlackRoth,
  software development company,
  custom software development company,
  custom software development hyderabad,
  software engineering,
  software consulting,
  application development,
  enterprise software Development,
  enterprise solutions,
  enterprise applications,
  business software solutions,
  digital platforms,
  software modernization,

  digital transformation,
  business transformation,
  enterprise transformation,
  intelligent automation,
  digital innovation,
  technology consulting,
  digital strategy,
  process automation,
  enterprise modernization,
  business optimization,

  artificial intelligence,
  artificial intelligence solutions,
  enterprise AI,
  AI consulting,
  machine learning,
  generative AI,
  deep learning,
  natural language processing,
  NLP solutions,
  large language models,
  LLM development,
  LLM development company,
  predictive analytics,
  business intelligence,
  data engineering,
  data analytics services,
  intelligent decision making,
  computer vision,
  object detection,

  cloud transformation,
  cloud consulting,
  cloud infrastructure,
  cloud engineering,
  cloud architecture,
  cloud migration,
  DevOps services,
  DevOps consulting,
  kubernetes,
  containerization,
  multi cloud solutions,
  AWS consulting,
  Azure consulting,
  Google Cloud services,

  cybersecurity,
  information security,
  cyber resilience,
  threat detection,
  vulnerability assessment,
  penetration testing,
  security operations center,
  SOC services,
  managed security services,
  risk management,
  compliance management,
  governance risk and compliance,
  identity management,
  data protection,
  network security,

  web development company,
  website development,
  frontend development,
  backend development,
  full stack development,
  ecommerce development,
  progressive web apps,
  react development,
  mobile app development company,
  android app development,
  ios app development,
  cross platform app development,
  UI engineering,
  UI UX design,

  IoT integration,
  IoT solutions,
  connected devices,
  smart systems,
  edge computing,
  edge AI,
  low latency processing,

  research and development,
  innovation,
  autonomous navigation,
  robotics,
  intelligent systems,

  workforce management,
  HR automation,
  talent management,
  employee engagement,
  HR technology,
  payroll automation,
  workforce analytics,
  employee lifecycle management,
  performance management,
  talent acquisition,
  human capital management,
  HCM solutions,
  payroll services,
  HR outsourcing india,
  HR services,

  business process outsourcing,
  business process management,
  managed services,
  shared services,
  customer experience management,
  customer success,
  business support services,
  operational excellence,
  digital operations,
  outsourcing solutions,
  process optimization,
  customer support,
  technical support,

  software company Hyderabad,
  IT company Hyderabad,
  IT Consulting Services,
  AI company Hyderabad,
  AI development company Hyderabad,
  software development company hyderabad,
  software development company India,
  technology consulting India,

  trusted technology partner,
  enterprise technology partner,
  innovation driven company,
  scalable solutions,
  digital excellence,
  future ready solutions,
  business growth solutions
`;

const SEO = ({
  title,
  description,
  keywords,
  canonical,
  image,
  type = "website",
  schema = null,
  includeDefaultOrganizationSchema = false,
  robots = "index, follow, max-image-preview:large",
}) => {
  const hasExplicitPageMeta = Boolean(title || description || canonical || image);
  const resolvedKeywords = keywords || (hasExplicitPageMeta ? DEFAULT_KEYWORDS : "");
  const hasPageMeta = Boolean(
    title || description || resolvedKeywords || canonical || image
  );

  return (
    <Helmet>
      {/* Basic SEO */}
      {title ? <title>{title}</title> : null}
      {description ? <meta name="description" content={description} /> : null}
      {resolvedKeywords ? (
        <meta name="keywords" content={resolvedKeywords} />
      ) : null}
      {hasPageMeta ? (
        <meta name="robots" content={robots} />
      ) : null}
      {canonical ? <link rel="canonical" href={canonical} /> : null}

      {/* Open Graph */}
      {hasPageMeta ? <meta property="og:type" content={type} /> : null}
      {hasPageMeta ? <meta property="og:site_name" content="BlackRoth" /> : null}
      {title ? <meta property="og:title" content={title} /> : null}
      {description ? <meta property="og:description" content={description} /> : null}
      {canonical ? <meta property="og:url" content={canonical} /> : null}
      {image ? <meta property="og:image" content={image} /> : null}

      {/* Twitter */}
      {hasPageMeta ? <meta name="twitter:card" content="summary_large_image" /> : null}
      {title ? <meta name="twitter:title" content={title} /> : null}
      {description ? <meta name="twitter:description" content={description} /> : null}
      {image ? <meta name="twitter:image" content={image} /> : null}

      {/* Author */}
      {hasPageMeta ? <meta name="author" content="BlackRoth" /> : null}

      {/* Theme */}
      {hasPageMeta ? <meta name="theme-color" content="#000000" /> : null}

      {/* Structured Data */}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}

      {/* Default Organization Schema */}
      {!schema && includeDefaultOrganizationSchema && (
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "BlackRoth",
            url: "https://blackroth.in",
            logo: "https://blackroth-images.s3.ap-south-1.amazonaws.com/BlackRoth1.png",
            description:
              "BlackRoth is a technology company specializing in AI, Software Development, Cloud Solutions, Cybersecurity, HR & Payroll Services, and Business Process Outsourcing.",
            sameAs: [
              "https://www.linkedin.com/company/blackroth",
              "https://www.instagram.com/blackroth",
              "https://twitter.com/blackroth"
            ]
          })}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
